export default "__VITE_ASSET__6ed4863f__"